/* UploadFX: hover popup on product-card star ratings — review count + a 5→1 star
   distribution bar chart, pulled from the reviews Worker. Data is PREFETCHED on load
   so the popup appears instantly on hover (no fetch lag). */
(function () {
  if (window.__ufxRatingPop) return;
  window.__ufxRatingPop = true;

  var ENDPOINT = "https://quickdraw-licence.uploadfxshop-26e.workers.dev/reviews?product=";
  var cache = {}; // slug -> data | 'loading'

  function distribution(reviews) {
    var d = [0, 0, 0, 0, 0]; // index 0 = 1★ ... index 4 = 5★
    (reviews || []).forEach(function (r) {
      var k = Math.round(r.rating);
      if (k >= 1 && k <= 5) d[k - 1]++;
    });
    return d;
  }

  function render(pop, j) {
    var d = distribution(j.reviews);
    var total = (j.reviews && j.reviews.length) || j.count || 1;
    var rows = "";
    for (var s = 5; s >= 1; s--) {
      var n = d[s - 1];
      var pct = total ? Math.round((n / total) * 100) : 0;
      rows += '<div class="ufx-rp-row"><span class="ufx-rp-star">' + s + '★</span>'
        + '<span class="ufx-rp-bar"><i style="width:' + pct + '%"></i></span>'
        + '<span class="ufx-rp-n">' + n + '</span></div>';
    }
    pop.innerHTML = '<div class="ufx-rp-head"><b>' + (j.average || 0).toFixed(1) + '</b> '
      + j.count + ' review' + (j.count === 1 ? '' : 's') + '</div>' + rows;
  }

  function fetchSlug(slug) {
    if (cache[slug] && cache[slug] !== "error") return Promise.resolve(cache[slug]);
    cache[slug] = "loading";
    return fetch(ENDPOINT + encodeURIComponent(slug))
      .then(function (r) { return r.json(); })
      .then(function (j) { cache[slug] = (j && j.ok) ? j : { ok: false, count: 0 }; return cache[slug]; })
      .catch(function () { cache[slug] = "error"; return cache[slug]; });
  }

  function showFromCache(host, pop) {
    var c = cache[host.getAttribute("data-ufx-slug")];
    if (c && c !== "loading" && c !== "error" && c.ok && c.count) {
      render(pop, c);
      pop.removeAttribute("hidden");
      return true;
    }
    return false;
  }

  function bind(host) {
    if (host.__ufxBound) return;
    host.__ufxBound = true;
    var pop = host.querySelector(".ufx-rating-pop");
    if (!pop) return;
    var slug = host.getAttribute("data-ufx-slug");

    fetchSlug(slug); // prefetch now -> instant on hover

    var open = function () {
      host.__want = true;
      if (showFromCache(host, pop)) return;
      // still loading (hovered very early): show as soon as it lands, if still wanted
      fetchSlug(slug).then(function () { if (host.__want) showFromCache(host, pop); });
    };
    var close = function () { host.__want = false; pop.setAttribute("hidden", ""); };

    host.addEventListener("mouseenter", open);
    host.addEventListener("focus", open);
    host.addEventListener("mouseleave", close);
    host.addEventListener("blur", close);
  }

  function scan() {
    document.querySelectorAll(".ufx-rating-hover[data-ufx-slug]").forEach(bind);
  }

  if (document.readyState !== "loading") scan();
  else document.addEventListener("DOMContentLoaded", scan);

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
